import React, { useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { styled } from '@mui/styles';
import { openSnackbarAction } from '../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../shared/components/snackbar/snackbar-types';
import {
  useFlushMetaApiCloudAccountMutation,
  useMetaApiCloudAccountLazyQuery,
} from '../../shared/types/generated';
import { useAuth } from '../auth/auth-hooks';
import moment from 'moment';
import { Loading } from '../../shared/components/Loading';

const StyledButton = styled(ButtonDefault)({
  borderRadius: '5px!important',
  backgroundColor: '#44DD29!important',
  border: 'none!important',
  color: 'white!important',
  minWidth: 130,
  '&:disabled': {
    backgroundColor: '#44DD29!important',
  },
  height: 45,
});
export const SettingFlush: React.FC = () => {
  const { user } = useAuth();

  const [callAccount, { data, loading: loadingAccount }] = useMetaApiCloudAccountLazyQuery();


  const [callAction, { loading }] = useFlushMetaApiCloudAccountMutation({
    onCompleted: () => {
      callAccount();
      openSnackbarAction('Update suspended date successfully!', TypeMessage.SUCCESS);
    },
  });

  useEffect(() => {
    if (user) {
      callAccount({
        variables: {
          where: {
            user_id: user.id,
          },
        },
      });
    }

  }, [callAccount, user]);

  if (loadingAccount) return <Loading height={'300px'} />;


  return (
    <Box pt={2}>
      <Grid container>
        <Grid item xs={12} mb={1}>
          <StyledButton isLoading={loading} onClick={() => callAction()}>
            RESTART SUSPENDED DATE
          </StyledButton>
        </Grid>
        <Grid item xs={12}>
          <Box display='flex'>
            <Typography style={{ fontWeight: 'bold' }}>Suspended:</Typography>
            <Typography>{data?.metaApiCloudAccount?.suspended_at ? `Yes (${moment(data?.metaApiCloudAccount?.suspended_at).tz('America/New_York').format('LLL')})` : 'No'}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
